<template>
    <div class="KeywordListPage">
        <zPage :contentState="pageContentState"
               :sidebar="true">
            <template v-slot:headerTitle>{{ gettext('Продвижение на картах - модуль Local Pack') }}</template>
            <template v-slot:headerDescription>{{ gettext('Инструмент оценки результатов продвижения карточек компании на картах.') }}
                <a @click="openModal1"
                   class="a-button a-button--link a-button--action">{{ gettext('Подробнее') }}</a>
            </template>
            
            <template v-slot:topBar>
                <div class="buttonGroup">
                    <button class="button" v-on:click="chooseTab('branches')" v-bind:class="{'--active': isBranchesTab}">{{ gettext('по филиалам') }}
                    </button>
                    <button class="button" v-on:click="chooseTab('keywords')" v-bind:class="{'--active': isKeywordsTab}">{{ gettext('по ключевикам') }}
                    </button>
                </div>

                <div style="margin-left: 100px">
                    <router-link :to="{ name: 'KeywordsManagement' }">
                        <button class="button button--primary">{{ gettext('Управление ключевиками') }}</button>
                    </router-link>
                </div>
            </template>

            <template v-slot:main>
                <div class="xCard xCard--column">
                    <div class="xCard__body">
                        <zPaginator ref="paginator"
                                    :paginator="paginator"
                                    :pending="domains.keywords.query.pending"
                                    @changePage="changePage"
                                    @changePageSize="changePageSize">
                            <div class="tableGroup">
                                <zTable v-bind="tableState"
                                        @onNameClick="chooseKeyword($event)"
                                        @onInfoClick="onInfoClick($event)"
                                        @sort="sortBy"></zTable>
                                <zTable v-bind="tableState__source" @onPositionInfoClick="showPositionHistory"></zTable>
                            </div>
                        </zPaginator>
                    </div>

                    <zPopup :custom-options="historyPopupOptions" :multi-trigger="true" ref="positionHistoryPopup">
                        <div class="popup__header">{{ gettext('История позиций') }}</div>
                        
                        <div v-if="historyPopupOptions.positionHistory.length">
                            <div class="popup__item popup__item--noPointer" v-for="item of historyPopupOptions.positionHistory" :key="item.date">
                                {{ item.date }} - {{ item.position === null ? '---' : item.position }} </div>
                        </div>
                        
                        <div v-else class="popup__noData">{{ gettext('Данных нет') }}</div>
                    </zPopup>
                </div>
            </template>

            <template v-slot:sidebar>
                <div class="statsDateInfo">
                    <div class="__showDate">{{ gettext('Статистика за') }} {{ statsForDate }}</div>
                    <div class="__nextDate">{{ gettext('Следующее обновление') }} {{ nextStatsUpdate }}</div>
                </div>
                
                <FilterBlock :query="domains.keywords.query"
                             :filters="filterFields"
                             @filterQueryParamChanged="getList"></FilterBlock>
            </template>
        </zPage>

        <!--    <pre style="margin-top: 30px; padding: 20px; background: #fafafa">{{ domains.keywords.query | prettyJson }}</pre>-->

        <Modal v-model="modal1"
               :title="gettext('Информация о разделе')"
               footer-hide>
            <div class="about-repometr">
                <div class="info-block info-block--flat" style="margin-bottom: 0">
                    <div class="info-block__title">{{ gettext('Что такое LocalPack и как его использовать для привлечения клиентов?') }}</div>
                    <div class="info-block__body">
                        <p>{{ gettext('Клиенты приходят к вам, когда находят карточку компании по ключевым запросам. В блоке карт результатов поисковой выдачи отображаются карточки филиалов вашей компании и карточки конкурентов.') }}
                        </p>
                    </div>
                </div>

                <img src="/static/images/local-pack/localpack_branches_info_1.png">

                <div class="promo-block">{{ gettext('Для получения максимального числа обращений клиентов важно быть выше конкурентов в результатах поиска.') }}</div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Основные факторы, которые влияют на позиции карточек филиалов:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('рейтинг филиала;') }}</li>
                            <li>{{ gettext('работа с отзывами - новые отзывы с ответами оцениваются выше, уровень профиля пользователя, оставившего отзыв (например, “местный эксперт 8 уровня”), оценки клиентов;') }}</li>
                            <li>{{ gettext('наличие ключевых слов поисковых запросов в описании компании, текстах отзыва и ответов;') }}</li>
                            <li>{{ gettext('полнота данных профиля - заполнены категории, адресные данные, добавлены фотографии;') }}</li>
                            <li>{{ gettext('регулярное обновление и актуализация данных;') }}</li>
                            <li>{{ gettext('внешние ссылки на карточку филиала (требует участия SEO-специалиста).') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Работать над улучшением этих факторов можно в интерфейсе и сервисах Repometr в разделах:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('Отзывы') }}</li>
                            <li>{{ gettext('Филиалы') }}</li>
                            <li>{{ gettext('Мониторинг') }}</li>
                            <li>{{ gettext('Работа с клиентами') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="info-block info-block--promo" :hidden=isDemoPage>
                    <div v-if="aboutRepometrFormResponse">
                        <span class="form-response">{{ aboutRepometrFormResponse.message }}</span>
                    </div>
                    <div v-else>
                        <div class="info-block__title">
                            {{ gettext('Или можно доверить продвижение карточек филиалов нашей профессиональной команде. Для этого отправьте заявку.') }}
                        </div>
                        <div class="info-block__body">
                            <form>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Как к Вам обращаться?') }}</div>
                                    <Input v-model="aboutRepometrForm.name"
                                           type="text"
                                           name="name"
                                           placeholder="Имя"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Укажите номер телефона или e-mail') }}</div>
                                    <Input v-model="aboutRepometrForm.phone"
                                           type="text"
                                           name="phone"
                                           placeholder="Телефон"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <Input v-model="aboutRepometrForm.email"
                                           type="text"
                                           name="email"
                                           placeholder="E-mail"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <button class="button button--primary"
                                            @click.prevent="createHelpRequest">{{ gettext('Отправить') }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {baseUrl} from "@/1_webapi/api";
import {fetchKeywordBranches} from "@/1_webapi/mocks";
import {makeBaseComponent} from "@/2_app-logic/models";
import {
    ColumnTypes,
    getColumnsForSourceTable, makeSourceDataForTable_keywordGroup,
    sourceColumnsCountStyle
} from "@/2_app-logic/utils/utils";
import FilterBlock from "@/3_view/components/FilterBlock";
import zPage from "@/3_view/core/zPage";
import zPaginator from "@/3_view/core/zPaginator";
import zPopup from "@/3_view/core/zPopup";
import zTable from "@/3_view/core/zTable";
import {api} from "@/main";
import {createNamespacedHelpers} from "vuex";

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('KeywordList');

export default {
    name: 'KeywordList',
    components: {
        zPage, zTable, zPopup, zPaginator, FilterBlock,
    },
    props: {
        isDemoPage: Boolean
    },
    mixins: [makeBaseComponent({ mapState, mapGetters, mapActions })],
    data() {
        return {
            modal1: false,
            aboutRepometrForm: {
                name: '',
                phone: '',
                email: '',
            },
            aboutRepometrFormResponse: null,
            historyPopupOptions: {
                popupId: 'positionHistoryPopup',
                triggerElUniqSelector: '#LocalPack .tableCell__content.--clickable.showInfoPopup',
                containerElUniqSelector: '#LocalPack .xCard .tableGroup',
                positionHistory: [],
                heightCompensation: 22,
                widthCompensation: 10,
            },
            columns: [
                {
                    name: this.gettext('Ключевые слова'),
                    type: ColumnTypes.string,
                    isAscSort: true,
                    isSort: false,
                    isSortable: true,
                    sortingKey: 'keyword',
                    isClickable: true,
                },
                {
                    name: this.gettext('Частотность'),
                    type: ColumnTypes.integer,
                    isAscSort: true,
                    isSort: false,
                    isSortable: false,
                    sortingKey: 'frequency',
                },
                // {
                //     name: this.gettext('Позиция'),
                //     type: ColumnTypes.integer,
                //     isAscSort: true,
                //     isSort: false,
                //     infoIcon: true,
                //     isClickable: true,
                // },
            ],
            filterFields: [
                'keyword_q',
                'keyword',
                // 'source_id',
                // 'date'
            ]
        }
    },
    computed: {
        ...mapState([
            'domains',
        ]),
        ...mapGetters([
            'paginator',
            'keywords',
            'time',
        ]),
        columnsNameMap() {
            /*hint:
            ключи Object'а нельза оборачивать функциями gettext -> 
            сначала создать new Map с переведенными ключами -> 
            потом перевести Map в Object
            */
            const transColumns = [this.gettext('Ключевые слова'), this.gettext('Частотность'), this.gettext('Позиция')]
            let transMap = new Map();
            transMap.set(transColumns[0], 'name');
            transMap.set(transColumns[1], 'frequency');
            transMap.set(transColumns[2], 'position');
            const res = Object.fromEntries(transMap)
            return res;
        },
        isInitDataReady() {
            return !!(this.paginator && this.keywords.length)
        },
        pageContentState() {
            return {
                pending: this.domains.keywords.query.pending,
                isInitDataReady: this.isInitDataReady,
                notExistText: this.gettext('Список ключевиков пуст'),
            }
        },
        currentTab() {
            return this.$store.getters.currentTab
        },
        isBranchesTab() {
            return this.currentTab === 'branches'
        },
        isKeywordsTab() {
            return this.currentTab === 'keywords'
        },
        statsForDate() {
            const time = this.time && this.time.statsForDate
            return time ? new Date(time).toLocaleDateString() : ''
        },
        nextStatsUpdate() {
            const time = this.time && this.time.nextStatsUpdate
            return time ? new Date(time).toLocaleDateString() : ''
        },
        columns__source() {
            return getColumnsForSourceTable(this.keywords)
        },
        data__source() {
            return makeSourceDataForTable_keywordGroup(this.keywords)
        },
        tableState__source() {
            return {
                data: this.data__source,
                columns: this.columns__source,
                rowStyle: this.rowStyle__source,
                isZebraStyle: true,
                type: 'source',
                cellMinWidth: '160px',
                positionInfoTooltip: this.gettext('Посмотреть историю'),
            }
        },
        tableState() {
            return {
                data: this.keywords,
                columns: this.columns,
                rowStyle: this.rowStyle,
                columnsNameMap: this.columnsNameMap,
                type: 'usual'
            }
        },
        rowStyle() {
            return {'grid-template-columns': '1fr minmax(100px, 120px)'}
        },
        rowStyle__source() {
            return {'grid-template-columns': sourceColumnsCountStyle(this.columns__source.length)}
        },
        baseUrl() {
            return baseUrl()
        },
    },
    methods: {
        ...mapActions([
            'fetchKeywords',
            'sortBy',
        ]),
        async getList() {
            await this.fetchKeywords()
        },
        chooseKeyword(id) {
            this.$router.push({ name: 'RankByKeyword', params: {id} })
        },
        onInfoClick(payload) {
            if (payload.key === 'position') this.showKeywordBranches(payload.rowData)
        },
        async showKeywordBranches(keyword_row) {
            const branches = await fetchKeywordBranches(keyword_row.id)
    
            console.log(branches)
        },
        async showPositionHistory(event, source) {
            if (!source) {
                console.warn('В таблице нет данных по этому источнику.')
                return
            }
            
            this.historyPopupOptions.positionHistory = await api.common.getKeywordsListPositionHistory(source.keywordId, source.id)
            
            if (!this.historyPopupOptions.positionHistory) {
                console.error('positionHistory is empty')
            }
            
            this.$refs.positionHistoryPopup.triggerElementClickHandler(event)
        },
        chooseTab(value) {
            this.$store.dispatch('setCurrentTab', value)

            if (this.isBranchesTab) {
                this.$router.push({name: 'BranchList' })
            }
            else if (this.isKeywordsTab) {
                this.$router.push({name: 'KeywordList' })
            }
        },
        async openModal1() {
            this.modal1 = true
            if (!this.isDemoPage) {
                getUserDataAndFillInputs()
            }

            async function getUserDataAndFillInputs() {
                const data = await api.aboutRepometrHelpForm.getUserFormData()

                const inputs = document.querySelectorAll('.about-repometr form input')
                inputs.forEach(input => {
                    const value = data[input.name]
                    input.value = value ? value : ''
                })
            }
        },
        async createHelpRequest() {
            const data = await api.aboutRepometrHelpForm.createHelpRequest({ ...getFormValues()})
            this.aboutRepometrFormResponse = data
            function getFormValues() {
                const inputs = document.querySelectorAll('.about-repometr form input')
                const values = {}
                inputs.forEach(input => {
                    values[input.name] = input.value
                })
                return values
            }
        }
    },
    async mounted() {
        await this.getList()
    },
}
</script>

<style lang="less">

</style>